/**
 * SOAP改善提案カスタムフック
 *
 * TanStack Queryに移行済み:
 * - ポーリング（固定間隔2秒、最大2回）
 * - 提案の適用・却下はMutation化
 */
import {
  useSoapImprovementSuggestionsQuery,
  useApplySuggestionMutation,
  useDismissSuggestionMutation,
} from './queries/useSoapImprovementQuery'
import type {
  SoapImprovementSuggestion,
  ApplySuggestionResponse,
} from '@/apps/latest/features/formatter/types/soapImprovement'

interface UseSOAPImprovementOptions {
  pollingEnabled?: boolean
  maxPolls?: number
  pollInterval?: number
}

interface UseSOAPImprovementReturn {
  suggestions: SoapImprovementSuggestion[]
  isLoading: boolean
  isPolling: boolean
  error: Error | null
  applySuggestion: (
    suggestionId: string
  ) => Promise<ApplySuggestionResponse | null>
  dismissSuggestion: (suggestionId: string) => Promise<boolean>
  refetch: () => void
}

export const useSOAPImprovement = (
  yakurekiId: string | undefined,
  options: UseSOAPImprovementOptions = {}
): UseSOAPImprovementReturn => {
  const { suggestions, isLoading, isPolling, error, refetch } =
    useSoapImprovementSuggestionsQuery(yakurekiId, options)

  const applyMutation = useApplySuggestionMutation(yakurekiId)
  const dismissMutation = useDismissSuggestionMutation(yakurekiId)

  const applySuggestion = async (
    suggestionId: string
  ): Promise<ApplySuggestionResponse | null> => {
    return await applyMutation.mutateAsync(suggestionId)
  }

  const dismissSuggestion = async (suggestionId: string): Promise<boolean> => {
    try {
      await dismissMutation.mutateAsync(suggestionId)
      return true
    } catch {
      return false
    }
  }

  return {
    suggestions,
    isLoading,
    isPolling,
    error,
    applySuggestion,
    dismissSuggestion,
    refetch,
  }
}
